import _ from 'lodash';
import MemberUtils from 'web-core/src/utils/member';
import { RECEIVE_MEMBERS, SAVE_MEMBERS, UPDATE_MEMBERS, DELETE_MEMBER } from '../actions/members';
import { SAVE_MAILING_ADDRESS, DELETE_ADDRESS } from '../actions/address';

const initialState = [];

function mergeMemberArrays(oldMembers, newMembers) {
  const updates = oldMembers.reduce((agg, oldMember) => {
    const match = newMembers.find(({ id }) => id === oldMember.id);
    agg.push(Object.assign({}, oldMember, match || {}));
    return agg;
  }, []);

  const adds = newMembers.filter(newMember => !updates.find(({ id }) => newMember.id === id));
  return MemberUtils.sortMembers(updates.concat(adds));
}

export default function members(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_MEMBERS:
      return action.data.members;
    case SAVE_MEMBERS:
      return mergeMemberArrays(state, action.data.members);
    case UPDATE_MEMBERS:
      return mergeMemberArrays(state, action.data.members);
    case DELETE_MEMBER:
      return _.reject(state, { id: action.data.id });
    case SAVE_MAILING_ADDRESS:
      return state.map((member) => {
        if (action.memberId !== member.id) {
          return member;
        }

        const mailing_address = action.address;
        return {
          ...member,
          mailing_address,
          mailing_address_id: mailing_address.id,
        };
      });
    case DELETE_ADDRESS:
      return state.map((member) => {
        const { addressId } = action;
        const { address_id, mailing_address_id } = member;

        if (addressId !== address_id && addressId !== mailing_address_id) {
          return member;
        }

        const updatedMember = { ...member };
        if (addressId === address_id) {
          updatedMember.address_id = null;
          updatedMember.address = null;
        }

        if (addressId === mailing_address_id) {
          updatedMember.mailing_address_id = null;
          updatedMember.mailing_address = null;
        }

        return updatedMember;
      });
    default:
      return state;
  }
}
